export const LOGIN_HEADER = "login-header";
export const LOGIN_BUTTON = "login-perform-login-button";
export const LOGIN_OR_DIVIDER = "login-or-divider";
export const LOGIN_CREATE_ACCOUNT_LINK = "login-create-account-link";
export const LOGIN_CHALLENGE = "LOGIN_CHALLENGE";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const ACCOUNT_LOCKED = "ACCOUNT_LOCKED";
export const ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED";
export const ACCOUNT_DEACTIVATED = "ACCOUNT_DEACTIVATED";
export const ACCOUNT_DISABLED = "ACCOUNT_DISABLED";
export const DISABLED_DUE_TO_INACTIVITY = "DISABLED_DUE_TO_INACTIVITY";
export const LOGIN_ERROR_MESSAGE_DESC_1 = "login-error-message-desc-1";
export const LOGIN_ERROR_MESSAGE_DESC_2 = "login-error-message-desc-2";
export const LOGIN_ERROR_MESSAGE_DESC_3 = "login-error-message-desc-3";
export const LOGIN_ERROR_MESSAGE_DESC_4 = "login-error-message-desc-4";
export const LOGIN_USERNAME = "userName";
export const LOGIN_PASSWORD = "loginPassword";

export const REMOVE_VERIFICATION_METHOD_HEADER =
  "remove-verification-method-header";
export const REMOVE_VERIFICATION_METHOD_CONTENT_1 =
  "remove-verification-method-content-1";
export const REMOVE_VERIFICATION_METHOD_EMAIL = "email-label";
export const REMOVE_VERIFICATION_METHOD_PHONE = "phone-label";
export const REMOVE_VERIFICATION_METHOD_BUTTON =
  "remove-verification-method-button";
export const REMOVE_VERIFICATION_METHOD_MODAL_ID =
  "remove-verification-method-modal-id";
export const EMAIL_LABEL = "email";
export const PHONE_LABEL = "phoneNumber";
export const VERIFICATION_METHOD_REMOVED_SUCCESSFULLY =
  "VERIFICATION_METHOD_REMOVED_SUCCESSFULLY";
export const VERIFICATION_METHOD_UPDATED_SUCCESSFULLY =
  "VERIFICATION_METHOD_UPDATED_SUCCESSFULLY";
export const REMOVE_VERIFICATION_METHOD_ACTION = "remove";
export const EMAIL_FIELD = "email";
export const DATE_OF_BIRTH_FIELD = "dateOfBirth";
export const USERNAME_FIELD = "userName";
export const MONTH_AND_DAY_OF_BIRTH_FIELD = "monthDayOfBirth";

export const MAX_LOGIN_FIELD_LENGTH = /^\S.{0,49}$/;

export const LOGIN_USERNAME_REQUIRED_ERROR =
  "login-userName-required-error-message";
export const LOGIN_PASSWORD_REQUIRED_ERROR =
  "login-password-required-error-message";
